module.exports = __webpack_public_path__ + "static/img/dice-clear.c34b5a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dice-clear.png
// module id = 424
// module chunks = 1